import * as React from "react";

function IcContact24Hours(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcContact24Hours"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.36921 15.25H11.2868V13.7541H8.2667C8.31637 12.8367 11.1775 12.4078 11.1775 10.184C11.1775 8.66816 9.91582 8 8.75349 8C6.90567 8 6.25 9.53576 6.25 9.53576L7.54148 10.4034C7.54148 10.4034 7.91899 9.64546 8.59453 9.64546C8.96211 9.64546 9.35949 9.85488 9.35949 10.3535C9.35949 11.3807 6.28974 11.8494 6.28974 14.4821C6.28974 14.7215 6.31954 14.9708 6.36921 15.25Z"
        fill={accent}
      />
      <path
        d="M12.0377 13.5248H15.1869V15.25H16.9056V13.5248H17.75V12.0787H16.9056V8.11967H14.7796L12.0377 12.4677V13.5248ZM13.806 12.0787V12.0588L14.8789 10.4233C15.0776 10.1241 15.2266 9.68535 15.2266 9.68535H15.2465C15.2465 9.68535 15.1869 10.0942 15.1869 10.4832V12.0787H13.806Z"
        fill={accent}
      />
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2716 2 18.1763 3.57111 20.0007 6M20.0007 6H17M20.0007 6V3"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IcContact24Hours;
